import Color from "color";
import {irandomRange} from "./random";

export function getRandomColor(): Color {
    return Color.hsv(irandomRange(0, 360), irandomRange(140, 190)/255*100, irandomRange(200, 220)/255*100);
}

export function getDarkerColor(color: Color) {
    return Color.hsv(color.hue(), color.saturationv()-5/255*100, color.value()-100/255*100)
}